import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import { useToastContext } from "components/alert/ToastContext";
import AnexoPanel, { getFormData } from "components/anexo/AnexoPanel";
import InputMonetario from "components/input/InputMonetario";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import Viagem from "model/viagem/Viagem";
import ViagemDespesa from "model/viagem/ViagemDespesa";
import ViagemDespesaPrevista from "model/viagem/ViagemDespesaPrevista";
import ViagemTipoDespesa from "model/viagem/ViagemTipoDespesa";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import ViagemDespesaPrevistaService from "service/viagem/ViagemDespesaPrevistaService";
import ViagemDespesaService from "service/viagem/ViagemDespesaService";

type Props = {
    visible: boolean;
    onHide: () => void;
    viagemDespesaPrevista: ViagemDespesaPrevista;
}

const viagemDespesaPrevistaService = new ViagemDespesaPrevistaService();
export default function ModalViagemDespesaPrevistaEditar({ visible, onHide, viagemDespesaPrevista }: Props) {
    const { setError, formState: { errors }, register, clearErrors, control } = useForm();
    const { startLoading, stopLoading } = useLoadingContext();
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    const [tiposDespesa, setTiposDespesa] = useState<ViagemTipoDespesa[]>([]);

    const [despesaPrevista, setDespesaPrevista] = useState<ViagemDespesaPrevista>({ ...viagemDespesaPrevista });
    const [anexos, setAnexos] = useState<any[]>([]);
    const [panelCollapsedAnexos, setPanelCollapsedAnexos] = useState<boolean>(false);

    useEffect(() => {
        viagemDespesaPrevistaService.getTiposDespesa().then((response) => {
            setTiposDespesa(response)
        }).catch(err => {
            console.error(err);
        });
    }, [])

    function validarDespesaPrevista() {
        if (despesaPrevista.tipo === null) {
            setError("tipoDespesaPrevista", { type: "manual", message: "Tipo é Obrigatório" }, { shouldFocus: true });
            return false;
        }
        if (despesaPrevista.valor === null || despesaPrevista.valor === 0) {
            setError("valorDespesaPrevista", { type: "manual", message: "Valor é Obrigatório" }, { shouldFocus: true });
            return false;
        }
        return true;
    }

    const salvarDespesasPrevistas = (despesa: ViagemDespesaPrevista) => {
        startLoading();
        viagemDespesaPrevistaService.salvar(getFormData("despesa", despesa, anexos, "imagens")).then((response) => {
            msgSucesso("Sucesso", 'Registro gravado com sucesso');
            onHide()
        }).catch((err) => {
            console.error(err);
            if (err && err.data && err.data.message) {
                msgErro("Erro", err.data.message);
            } else {
                msgErro("Erro", 'Ocorreu um erro ao tentar gravar, tente novamente!');
            }
        }).finally(() => {
            stopLoading();
        })
    }


    return (
        <Dialog header="Despesa Prevista" visible={visible} style={{ width: '50vw' }}
            onHide={() => {
                onHide();
            }}>
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Tipo</Label>
                <div className="col-sm-12">
                    <Controller name="tipoDespesaPrevista" control={control} render={({ field }) => (
                        <Dropdown
                            focusInputRef={field.ref}
                            className={errors.atividade ? "p-invalid" : ""}
                            options={tiposDespesa}
                            optionLabel="nome"
                            placeholder="Selecione"
                            value={despesaPrevista.tipo}
                            style={{ width: '100%' }}
                            onChange={(e) => {
                                setDespesaPrevista({ ...despesaPrevista, tipo: e.value })
                                clearErrors("tipoDespesaPrevista")
                            }}
                        />
                    )} />
                </div>
                {errors.tipoDespesaPrevista && errors.tipoDespesaPrevista.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.tipoDespesaPrevista?.message as string}</span> : null}
            </div>
            <div className="row">
                <Label className="col col-sm-12">Observação</Label>
                <div className="col-sm-12">
                    <InputTextarea value={despesaPrevista.observacao} rows={2} style={{ width: '100%' }}
                        onChange={(e) => {
                            setDespesaPrevista({ ...despesaPrevista, observacao: e.target.value })
                        }}
                    />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Valor</Label>
                <div className="col-sm-12">
                    <Controller name="valorDespesaPrevista" control={control} render={({ field }) => (
                        <InputMonetario value={despesaPrevista.valor}
                            onChange={(e) => {
                                setDespesaPrevista({ ...despesaPrevista, valor: e })
                                clearErrors("valorDespesaPrevista")
                            }}
                        />
                    )} />
                </div>
                {errors.valorDespesaPrevista && errors.valorDespesaPrevista.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.valorDespesaPrevista?.message as string}</span> : null}
            </div>
            <div className="row">
                <Label className="col col-sm-12">Forma de Pagamento</Label>
                <div className="col-sm-12">
                    <Dropdown value={despesaPrevista.formaPagamento}
                        options={[
                            { label: "Não informada", value: null },
                            { label: "Dinheiro", value: "DINHEIRO" },
                            { label: "Crédito", value: "CREDITO" },
                            { label: "Pagamento Antecipado", value: "PAGAMENTO_ANTECIPADO" },
                        ]} placeholder="Selecione" style={{ width: '100%' }}
                        onChange={(e) => {
                            setDespesaPrevista({ ...despesaPrevista, formaPagamento: e.value })
                        }} />
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <AnexoPanel
                        novosAnexos={anexos} onChangeNovosAnexos={(e: any) => setAnexos(e)}
                        arquivos={despesaPrevista.imagens} onChange={(e) => {
                            setDespesaPrevista({ ...despesaPrevista, imagens: e })
                        }}
                        collapsed={panelCollapsedAnexos} onToggle={(e) => setPanelCollapsedAnexos(e.value)}
                    />
                </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                <Button label="Confirmar"
                    onClick={() => {
                        if (validarDespesaPrevista()) {
                            salvarDespesasPrevistas(despesaPrevista)
                        }
                    }} style={{ marginLeft: 8 }} />
            </div>

        </Dialog>
    );
}